module.exports = __webpack_public_path__ + "static/CodeDev-ca183cd8e0bcd97d9c115c5b9f5ee69f.svg";